export const FLIGHT_REQUEST = "FLIGHT_REQUEST";
export const FLIGHT_FAILURE = "FLIGHT_FAILURE";

export const GET_FLIGHT_SUCCESS = "GET_FLIGHT_SUCCESS";
export const POST_FLIGHT_SUCCESS = "POST_FLIGHT_SUCCESS";

export const FETCH_FLIGHTS = "FETCH_FLIGHTS";
export const DELETE_FLIGHTS = "DELETE_FLIGHTS";
